import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { SigningRequestChannel } from 'ngx-mat-esign360';
import { IButtonToggleGroupOption } from '@app/shared/model/button-toggle-group-option.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'app-signing-request-channel-select',
  templateUrl: './signing-request-channel-select.component.html',
  styleUrls: ['./signing-request-channel-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SigningRequestChannelSelectComponent),
      multi: true,
    },
  ],
})
export class SigningRequestChannelSelectComponent implements OnInit, ControlValueAccessor {
  constructor(private translate: TranslateService) {}
  @Input() value: SigningRequestChannel = SigningRequestChannel.None;
  @Output() typeSelect = new EventEmitter<SigningRequestChannel>();
  options: IButtonToggleGroupOption[] = [
    {
      value: SigningRequestChannel.None,
      textI18n: marker('SIGNING_REQUEST_CHANNEL_SELECTOR.DONT_SEND'),
      icon: 'cancel',
    },
    {
      value: SigningRequestChannel.Email,
      textI18n: marker('SIGNING_REQUEST_CHANNEL_SELECTOR.VIA_EMAIL'),
      icon: 'mail_outline',
    },
    {
      value: SigningRequestChannel.SMS,
      textI18n: marker('SIGNING_REQUEST_CHANNEL_SELECTOR.VIA_SMS'),
      icon: 'sms',
    },
  ];
  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit(): void {}

  onSelect(value: SigningRequestChannel) {
    this.setValue(value);
  }

  setValue(value: SigningRequestChannel) {
    this.value = value;
    this.onChange(value);
    this.typeSelect.emit(value);
    this.onTouched();
  }

  writeValue(value: SigningRequestChannel) {
    this.setValue(value);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
